module.exports = __webpack_public_path__ + "img/thumbnail.ed543325.jpeg";